export const quickOptionsDefaultValues = {
	weight: ["24", "22", "1.5"],
	length: ["13.6", "7.5", "3.6"],
	vehicleTypeId: ["TRAILER", "WAGGON_AND_DRAG", "VEHICLE_UP_TO_3_5_T"],
	// vehicleBodyId: ["CURTAIN_SIDER", "TAUTLINER", "REFRIGERATOR"],
	vehicleBodyId: ["CURTAIN_SIDER", "REFRIGERATOR"],
	additionalRequirements: [
		"adr",
		"non-slip_mats",
		"corner_protector",
		"transport_lines",
		"exchangable_pallete",
	],
};

export const defaultValues = {
	loadingRepeat: "",
	loadingAddress: "",
	unloadingAddress: "",
	loadingDate: "",
	unloadingDate: "",
	loadingAddressCountry: "",
	loadingDateType: "day",
	privateNote: "",
	unloadingAddressCountry: "",
	unloadingDateType: "day",
	isFtl: "true",
	weight: "",
	length: "",
	vehicleTypeId: [],
	vehicleBodyId: [],
	price: "",
	customerPrice: "",
	additionalRequirements: [],
	payment: "",
	publicNote: "",
	loadingAddressCustomPostalCode: "",
	loadingAddressCustomCity: "",
	loadingAddressCustomCountry: "",
	unloadingAddressCustomPostalCode: "",
	unloadingAddressCustomCity: "",
	unloadingAddressCustomCountry: "",
	shouldPostAfter: "0",
	loadingTimeStart: "",
	loadingTimeEnd: "",
	unloadingTimeStart: "",
	unloadingTimeEnd: "",
	mailingGroups_1: "",
	mailingGroups_2: "",
	mailingGroups_3: "",
};
